// src/hooks/useSmoothScroll.ts
'use client';

import { useEffect } from 'react';

/**
 * A hook that enables smooth scrolling behavior for the page.
 * Sets document.documentElement.style.scrollBehavior to 'smooth' when the component mounts
 * and resets it to 'auto' when the component unmounts.
 */
export function useSmoothScroll() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
}
